<template>
  <span class="base-mit-url-params">
    <v-chip v-for="(val, name, index) in params" :key="index" class="mr-1" close color="primary" label @click:close="remove(name, val)">{{name}}={{displayFormat(val)}}</v-chip>
  </span>
</template>

<script>
import moment from 'moment';

export default {
  name: 'BaseMitUrlParams',
  components: {},
  props: {
  },
  data: function() {
    return {
      params:{}
    }
  },
  mounted() {
    this.get();
  },
  methods : {
    displayFormat(val){
      if(moment(val, "YYYY-MM-DD HH:mm:ss", true).isValid() === true){
        // return moment(val).local().format('YYYY-MM-DD HH:mm:ss').toString();
        return moment.utc(val, "YYYY-MM-DD HH:mm:ss").local().format("YYYY-MM-DD HH:mm:ss").toString();
        //return val;
      }
      else{
        return val;
      }
    },
    remove(name,val){
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.delete(name);

      //update url
      var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
      history.pushState(null, '', newRelativePathQuery);
      this.get();

      this.$emit('removed',{
        itemName:name,
        itemValue:val
      });
    },
    get(){
      const urlSearchParams = new URLSearchParams(window.location.search);
      this.params = Object.fromEntries(urlSearchParams.entries());

      this.$emit('changed',this.params);
    },
    add(name, val){
      //will cause a page load, so if that's not desirable use the History API as follows:
      if ('URLSearchParams' in window) {
        var searchParams = new URLSearchParams(window.location.search)
        searchParams.set(name, val);
        var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
        history.pushState(null, '', newRelativePathQuery);
        this.get();

        this.$emit('added',{
          itemName:name,
          itemValue:val
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
